// The backend runs in UTC (APP_TIMEZONE=UTC) and returns timestamps like
// "2026-10-01 03:00:00" with no offset. new Date()/moment() treat such strings as
// browser-local time, so users east of UTC see times shifted back by their offset.
// Interpret offset-less strings as UTC; leave values that already carry a zone as-is.
export const parseServerDate = (value) => {
    if (!value) return null;
    if (typeof value !== 'string') return new Date(value);
    const hasZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(value.trim());
    return new Date(hasZone ? value : value.trim().replace(' ', 'T') + 'Z');
};
